'use strict';

// コレクション/検索ページ用：戻る時にスクロール位置を復元（Safariの戻るボタン対策版）
(function () {
    if (!(/\/collections\//.test(location.pathname) || /^\/search/.test(location.pathname))) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'auto';

    const KEY = 'scroll:' + location.pathname + location.search;
    const getY = () => window.scrollY || document.documentElement.scrollTop || 0;

    // 位置保存：pagehide に加えて visibilitychange/beforeunload でも保険をかける
    const save = () => sessionStorage.setItem(KEY, String(getY()));
    window.addEventListener('pagehide', save, {passive: true});
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) save();
    }, {passive: true});
    window.addEventListener('beforeunload', save, {passive: true});

    // 復元ロジック（現在位置が十分下がっていなければ上書き復元）
    function restoreIfNeeded() {
        const saved = Number(sessionStorage.getItem(KEY) || 0);
        if (!saved) return;

        // すでに復元されていれば触らない（誤差 16px 以内は復元済み扱い）
        if (Math.abs(getY() - saved) <= 16) return;

        const restore = () => window.scrollTo(0, saved);
        requestAnimationFrame(() => {
            // レイアウトシフト対策の複数回試行
            [0, 60, 200, 400].forEach(t => setTimeout(restore, t));
        });
    }

    window.addEventListener('pageshow', function (e) {
        // これまで：persisted のときは必ず return していた
        // 修正後：persisted でも「位置が上がってしまっている」なら復元を実行
        if (e.persisted) {
            // bfcache復帰でも位置が0等なら上書き復元
            if (getY() < 32) restoreIfNeeded();
            return;
        }
        // 再読込の場合は普通に復元
        restoreIfNeeded();
    }, {passive: true});
})();

window.addEventListener('DOMContentLoaded', () => {
    //==================================================================================================================
    if (!location.pathname.startsWith('/search')) {
        setupCollSearchBnrVideo();
    }

    function setupCollSearchBnrVideo() {
        const videos = document.querySelectorAll('.js-collSearchBnr__video');
        if (!videos.length) return;

        const isPc = window.matchMedia('(min-width: 750px)').matches;

        videos.forEach((video) => {
            const src = isPc ? video.dataset.pc : video.dataset.sp;

            if (!src) return;

            if (video.getAttribute('src') !== src) {
                video.setAttribute('src', src);
                video.load();
            }

            video.classList.add('js-loaded');

            const playPromise = video.play();
            if (playPromise) {
                playPromise.catch(() => {});
            }
        });
    }

    const collSearchBnrVideoMediaQuery = window.matchMedia('(min-width: 750px)');
    if (collSearchBnrVideoMediaQuery.addEventListener) {
        collSearchBnrVideoMediaQuery.addEventListener('change', setupCollSearchBnrVideo);
    } else {
        // 古いSafari対策
        collSearchBnrVideoMediaQuery.addListener(setupCollSearchBnrVideo);
    }

    //==================================================================================================================
    if (document.getElementById("js-refSearchBtn__blk--sort") != null) {
        let sortBtnArea = document.getElementById("js-refSearchBtn__blk--sort");
        if (document.getElementById("SortBy") != null) {
            let sortSelect = document.getElementById("SortBy");
            let currentUrl = location.href;
            if (currentUrl.includes("sort_by=manual")) {
                sortSelect.insertAdjacentHTML('afterbegin', '<option value="title" selected="selected">並び替え</option>');
            } else if (currentUrl.includes("sort_by=price")) {
                sortSelect.classList.add("js-sortPrice");
            } else {
                sortSelect.insertAdjacentHTML('afterbegin', '<option value="title" selected="selected">並び替え</option>');
            }
            sortBtnArea.appendChild(sortSelect);
            sortSelect.classList.add("js-loaded");
        }
    }

    do_search_filter();

    function do_search_filter() {
        let targets_result = document.querySelectorAll('.c-product-card2');
        let currentParameter = location.search;
        let arr_tast_tags = [
            'tasteModern',
            'tasteMidCentury',
            'tasteNatural',
            'tasteNordic',
            'tasteClassic',
            'tasteVintage',
            'tasteOffice',
            'tasteCafe',
            'tasteOther'
        ];

        let arr_color_tags = [
            'colorBlack',
            'colorWhite',
            'colorGraySilver',
            'colorGold',
            'colorWoodBrown',
            'colorClear',
            'colorOther'
        ];

        if (currentParameter.indexOf('tag:taste') >= 0 || currentParameter.indexOf('tag:color') >= 0) {
            for (let el of targets_result) {
                let is_show = false;
                let is_taste = false;
                let is_color = false;
                let tags = el.getAttribute('data-tags');

                if (currentParameter.indexOf('tag:taste') >= 0) {
                    for (let tag of arr_tast_tags) {
                        if (currentParameter.indexOf(tag) >= 0) {
                            if (tags.indexOf(tag) >= 0) {
                                is_taste = true;
                            }
                        }
                    }
                } else {
                    is_taste = true;
                }

                if (currentParameter.indexOf('tag:color') >= 0) {
                    for (let tag of arr_color_tags) {
                        if (currentParameter.indexOf(tag) >= 0) {
                            if (tags.indexOf(tag) >= 0) {
                                is_color = true;
                            }
                        }
                    }
                } else {
                    is_color = true;
                }

                is_show = is_taste && is_color;
                if (is_show === false) {
                    el.classList.add('js-disabled');
                } else {
                    el.classList.add('js-enabled');
                }
            }
        } else {
            for (let el of targets_result) {
                el.classList.add('js-enabled');
            }
        }
    }

    if (document.querySelector(".js-searchModal .js-c-searchPrice__btn") != null) {
        let refineSearchPriceAll = document.querySelectorAll('.js-searchModal .js-c-searchPrice__btn');
        refineSearchPriceAll.forEach(function (refineSearchPrice) {
            refineSearchPrice.addEventListener('click', function () {
                search_submit('.js-searchModal');
            });
        });
    }
    if (document.querySelector(".js-searchSidebar .js-c-searchPrice__btn") != null) {
        let refineSearchPriceAll = document.querySelectorAll('.js-searchSidebar .js-c-searchPrice__btn');
        refineSearchPriceAll.forEach(function (refineSearchPrice) {
            refineSearchPrice.addEventListener('click', function () {
                search_submit(".js-searchSidebar");
            });
        });
    }

    if (document.querySelector(".js-searchModal .js-search-item--check") != null) {
        const searchCheckboxAll = document.querySelectorAll('.js-searchModal .js-search-item--check');
        searchCheckboxAll.forEach(function (searchCheckbox) {
            searchCheckbox.addEventListener('change', function () {
                search_submit(".js-searchModal");
            });
        });
    }
    if (document.querySelector(".js-searchSidebar .js-search-item--check") != null) {
        const searchCheckboxAll = document.querySelectorAll('.js-searchSidebar .js-search-item--check');
        searchCheckboxAll.forEach(function (searchCheckbox) {
            searchCheckbox.addEventListener('change', function () {
                search_submit(".js-searchSidebar");
            });
        });
    }

    function search_submit(root_selector) {
        let target_root = document.querySelector(root_selector);
        let targets = target_root.querySelectorAll('.js-search-item');

        let cond = {
            'category': [],
            'kw': '',
            'scene': [],
            'taste': [],
            'series': [],
            'color': [],
            'price': {
                'low': '',
                'high': ''
            }
        };

        targets.forEach((el) => {
            if (el.getAttribute('data-category') === 'basetag') {
                if (el.getAttribute('data-tag') !== '') {
                    cond.category.push(el.getAttribute('data-tag'));
                }
            }
            if (el.getAttribute('data-category') === 'kw') {
                cond.kw = el.value;
            }
            if (el.getAttribute('data-category') === 'category' && el.checked) {
                cond.category.push(el.getAttribute('data-tag'));
            }
            if (el.getAttribute('data-category') === 'scene' && el.checked) {
                cond.scene.push(el.getAttribute('data-tag'));
            }
            if (el.getAttribute('data-category') === 'taste' && el.checked) {
                cond.taste.push(el.getAttribute('data-tag'));
            }
            if (el.getAttribute('data-category') === 'series' && el.checked) {
                cond.series.push(el.getAttribute('data-tag'));
            }
            if (el.getAttribute('data-category') === 'color' && el.checked) {
                cond.color.push(el.getAttribute('data-tag'));
            }
            if (el.getAttribute('data-category') === 'price' && el.getAttribute('data-price') === 'low') {
                cond.price.low = el.value;
            }
            if (el.getAttribute('data-category') === 'price' && el.getAttribute('data-price') === 'high') {
                cond.price.high = el.value;
            }
        });

        // 既存のURLパラメータから価格条件を取得して引き継ぐ
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('filter.v.price.gte') && cond.price.low === '') {
            cond.price.low = urlParams.get('filter.v.price.gte');
        }
        if (urlParams.has('filter.v.price.lte') && cond.price.high === '') {
            cond.price.high = urlParams.get('filter.v.price.lte');
        }

        if (cond.price.low !== '' || cond.price.high !== '') {
            if (cond.kw === '' && cond.category.length === 0 && cond.scene.length === 0 && cond.taste.length === 0 && cond.color.length === 0 && cond.series.length === 0) {
                if (window.location.pathname === '/collections/all') {
                    cond.kw = ' ';
                } else if (window.location.pathname.startsWith('/collections')) {
                    cond.kw = '';
                } else if (window.location.pathname.startsWith('/search')) {
                    cond.kw = ' ';
                }
            }
        }

        let qstr = '';
        let url_search = '/search?type=product&q=';
        let url_result = '';

        let currentUrl = location.href;
        let currentUrlPath = location.pathname;
        if (currentUrlPath === "/collections/lighting" || currentUrl.includes("tag:catLighting")) {
            cond.category.push("catLighting");
        } else if (currentUrlPath === "/collections/ceiling-light" || currentUrl.includes("tag:catCeiling")) {
            cond.category.push("catCeiling");
        } else if (currentUrlPath === "/collections/pendant-light" || currentUrl.includes("tag:catPendant")) {
            cond.category.push("catPendant");
        } else if (currentUrlPath === "/collections/spotlight" || currentUrl.includes("tag:catSpot")) {
            cond.category.push("catSpot");
        } else if (currentUrlPath === "/collections/floor-light" || currentUrl.includes("tag:catFloor")) {
            cond.category.push("catFloor");
        } else if (currentUrlPath === "/collections/desk-light" || currentUrl.includes("tag:catDeskLight")) {
            cond.category.push("catDeskLight");
        } else if (currentUrlPath === "/collections/bracket-light" || currentUrl.includes("tag:catBracket")) {
            cond.category.push("catBracket");
        } else if (currentUrlPath === "/collections/small-space" || currentUrl.includes("tag:catSmall")) {
            cond.category.push("catSmall");
        } else if (currentUrlPath === "/collections/outdoor-light" || currentUrl.includes("tag:catOutdoor")) {
            cond.category.push("catOutdoor");
        } else if (currentUrlPath === "/collections/custom-lighting" || currentUrl.includes("tag:catCustom")) {
            cond.category.push("catCustom");
        } else if (currentUrlPath === "/collections/light-bulb" || currentUrl.includes("tag:catBulb")) {
            cond.category.push("catBulb");
        } else if (currentUrlPath === "/collections/lighting-accessories" || currentUrl.includes("tag:catAccessories")) {
            cond.category.push("catAccessories");
        } else if (currentUrlPath === "/collections/furniture" || currentUrl.includes("tag:catFurniture")) {
            cond.category.push("catFurniture");
        } else if (currentUrlPath === "/collections/clock" || currentUrl.includes("tag:catClock")) {
            cond.category.push("catClock");
        } else if (currentUrlPath === "/collections/storage" || currentUrl.includes("tag:catStorage")) {
            cond.category.push("catStorage");
        } else if (currentUrlPath === "/collections/desk-chair" || currentUrl.includes("tag:catDeskChair")) {
            cond.category.push("catDeskChair");
        } else if (currentUrlPath === "/collections/dimmable-lighting-led" || currentUrl.includes("tag:dim_lighting_led")) {
            cond.category.push("dim_lighting_led");
        } else if (currentUrlPath === "/collections/dimmable-lighting-bulb" || currentUrl.includes("tag:dim_lighting_bulb")) {
            cond.category.push("dim_lighting_bulb");
        } else if (currentUrlPath === "/collections/lighting-smart-bulb" || currentUrl.includes("tag:dim_lighting_smartBulb")) {
            cond.category.push("dim_lighting_smartBulb");
        } else if (currentUrlPath === "/collections/dimmer-lighting" || currentUrl.includes("tag:dim_lighting_dimmer")) {
            cond.category.push("dim_lighting_dimmer");
        } else if (currentUrlPath === "/collections/dimmer-bulb-e17" || currentUrl.includes("tag:dim_bulbE17_dimmer")) {
            cond.category.push("dim_bulbE17_dimmer");
        } else if (currentUrlPath === "/collections/dimmer-bulb-e26" || currentUrl.includes("tag:dim_bulbE26_dimmer")) {
            cond.category.push("dim_bulbE26_dimmer");
        } else if (currentUrlPath === "/collections/other" || currentUrl.includes("tag:catOther")) {
            cond.category.push("catOther");
        }
        if (cond.kw) {
            qstr = cond.kw + ' AND ';
        }
        qstr += set_query(cond.category);
        qstr += set_query(cond.scene);
        qstr += set_query(cond.taste);
        qstr += set_query(cond.series);
        qstr += set_query(cond.color);

        if (cond.price.low !== '' && cond.price.high !== '') {
            qstr += '&filter.v.price.gte=' + cond.price.low + '&filter.v.price.lte=' + cond.price.high + '&';
        } else if (cond.price.low !== '' && cond.price.high === '') {
            qstr += '&filter.v.price.gte=' + cond.price.low;
        } else if (cond.price.low === '' && cond.price.high !== '') {
            qstr += '&filter.v.price.lte=' + cond.price.high;
        }

        url_result = url_search + qstr;

        if (url_result !== url_search) {
            location.href = url_result;
        }
    }

    function set_query(tags) {
        let qstr = '';
        tags.forEach(tag => {
            qstr += 'tag:' + tag + ' OR ';
        });
        return qstr.replace(/ OR $/, ' AND ');
    }

    function search_clear(root_selector) {
        let target_root = document.querySelector(root_selector);
        let targets = target_root.querySelectorAll('.js-search-item');

        targets.forEach((el) => {
            if (el.getAttribute('data-category') === 'kw') {
                el.value = '';
            }

            if (el.getAttribute('data-category') === 'price') {
                el.value = '';
            }
            el.checked = false;
        });
    }

    try {
        sorted();
    } catch {
    }

    function sorted() {
        let currentParameter = location.search;
        if (currentParameter.indexOf('?sort_by=price') >= 0) {
            let els = document.querySelectorAll('.c-product-card2');
            for (let el of els) {
                el.setAttribute('style', '');
            }
        }

        const selectElement = document.querySelector('.facet-filters__sort');
        selectElement.addEventListener('change', function (event) {
            if (event.target.value === "price-ascending" || event.target.value === "price-descending") {
                selectElement.classList.add("js-sortPrice");
            } else if (event.target.value === "manual") {
                selectElement.classList.add("js-sortManual");
            }
            location.href = location.href.split('?')[0] + '?sort_by=' + event.target.value;
        });
    }
});
